var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLine2Chart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0801 8.80672C22.1855 8.72122 22.3406 8.73711 22.4264 8.84231C22.5123 8.9478 22.4963 9.10374 22.3908 9.1896L14.2136 15.8449C14.1214 15.9198 13.9884 15.9182 13.8981 15.841L11.1342 13.4716L2.02671 19.3601C1.91249 19.434 1.76 19.4012 1.68615 19.287C1.61263 19.1729 1.64533 19.0212 1.75927 18.9474L11.0216 12.9588L11.0947 12.9271C11.1706 12.9078 11.2531 12.9252 11.315 12.9781L14.0616 15.3331L22.0801 8.80672Z",
    fill: "#596773"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0801 3.88116C22.1855 3.79567 22.3406 3.81156 22.4264 3.91676C22.5123 4.02225 22.4963 4.17819 22.3908 4.26405L14.2136 10.9193C14.1214 10.9943 13.9884 10.9927 13.8981 10.9155L11.1342 8.54601L2.02671 14.4346C1.91249 14.5084 1.76 14.4757 1.68615 14.3614C1.61263 14.2473 1.64533 14.0957 1.75927 14.0218L11.0216 8.03325L11.0947 8.00151C11.1706 7.98228 11.2531 7.99962 11.315 8.05249L14.0616 10.4075L22.0801 3.88116Z",
    fill: "#011E60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2757 8.24021L1.89299 14.2285V19.1946L11.2757 13.1636L14.2165 15.6774L22.5 8.77156V4.00189L14.2165 10.7284L11.2757 8.24021Z",
    fill: "#0054EC",
    fillOpacity: 0.16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2757 13.2365L1.89299 19.2248V21.1377C1.89299 21.6817 2.33404 22.1228 2.8781 22.1228H22.5V8.99816L14.2165 15.7246L11.2757 13.2365Z",
    fill: "#919EAB",
    fillOpacity: 0.16
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 21.2009V3.46893C1.5 3.33292 1.61026 3.22266 1.74628 3.22266C1.88229 3.22266 1.99256 3.33292 1.99256 3.46893V21.2009C1.99256 21.609 2.32334 21.9398 2.73139 21.9398H22.2354C22.3715 21.9398 22.4817 22.05 22.4817 22.1861C22.4817 22.3221 22.3715 22.4323 22.2354 22.4323H2.73139C2.05131 22.4323 1.5 21.881 1.5 21.2009Z",
    fill: "#596773"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine2Chart);
export default __webpack_public_path__ + "static/media/line2_chart.d9d2e8e1a8ea8a5a85110933160e9fbc.svg";
export { ForwardRef as ReactComponent };